module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#magazines",
      toString: function () {
        return this.url;
      }
    }